// context/MenuContext.js
import React, { createContext, useContext, useState } from "react";

const MenuContext = createContext();

export const MenuProvider = ({ children }) => {
  const [menuVisible, setMenuVisible] = useState(false);

  const toggleMenu = () => {
    if (menuVisible) {
      console.log("menu context visible false");
      setMenuVisible(false);
    } else {
      console.log("menu context visible true");
      setMenuVisible(true);
    }
  };

  return (
    <MenuContext.Provider value={{ menuVisible, toggleMenu }}>
      {children}
    </MenuContext.Provider>
  );
};

export const useMenu = () => useContext(MenuContext);
